import { TabularTypeAdapter } from './tabular-type.adapter';
import { DataFlowDSLAdapterRegistry, Metamodel, Owned } from 'shell-models-lib';
import { QuickbaseSettings } from '../../../dataflow/dataset-settings/quickbase-settings';
import { DatasetFormatType } from '../../../dataflow/dataset-settings/dataflow-dataset-settings';
import { DataFlowExpressionUtils } from '../expression.util';
import { DataFlowSource } from '../../../dataflow/dataflow-source';
import { DataFlowSink } from '../../../dataflow/dataflow-sink';

@DataFlowDSLAdapterRegistry.adapter({
    model: Metamodel.modelFor(QuickbaseSettings)
})
export class QuickbaseAdapter extends TabularTypeAdapter {
    public async toSourceDSL(setting: QuickbaseSettings): Promise<string[]> {
        const props = [];
        props.push(`store: '${DatasetFormatType.Quickbase}'`);
        props.push(`format: 'rest'`);
        if (setting.schemaName.expression) {
            props.push(`table: ${DataFlowExpressionUtils.wrapExpressionConfigValue(setting.schemaName)}`);
        }
        if (setting.tableName.expression) {
            props.push(`report: ${DataFlowExpressionUtils.wrapExpressionConfigValue(setting.tableName)}`);
        }
        return props;
    }

    public async toSourceModel(owner: DataFlowSource, configs: Map<string, string>, handledConfigs: string[]): Promise<QuickbaseSettings> {
        const setting = await super.toSourceModel(owner, configs, handledConfigs) as QuickbaseSettings;
        if (configs.has('table')) {
            setting.schemaName = DataFlowExpressionUtils.unwrapExpressionConfigValue(configs.get('table'), owner);
            handledConfigs.push('table');
        }
        if (configs.has('report')) {
            setting.tableName = DataFlowExpressionUtils.unwrapExpressionConfigValue(configs.get('report'), owner);
            handledConfigs.push('report');
        }
        return setting;
    }

    protected _generateSetting(owner: DataFlowSource | DataFlowSink): QuickbaseSettings {
        const setting = Owned.create<QuickbaseSettings>(QuickbaseSettings.MODEL, owner);
        setting.initialize(undefined);
        return setting;
    }
}
